import logo from "../LametHabayebLogo.png";
const Logo = (e) => {
    return (
      
            <img className= "text-center" src={logo} alt="Lamet Habayeb Logo"  style={{width:"200px", height:"100px"}}/>

    );
}
export default Logo;